import AutoScanApp from "./App";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { AuthenticatedHeader } from "@/components/portal/AuthenticatedHeader";
import { CurrencyDock } from "@/components/portal/CurrencyDock";
import { LogoShield } from "@/components/LogoShield";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function AutoScanPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const { data: isAdmin } = useQuery({
    queryKey: ["isAdmin", user?.id],
    queryFn: async () => {
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user!.id)
        .eq("role", "admin")
        .maybeSingle();
      return !!data;
    },
    enabled: !!user,
  });

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5" />
      <AuthenticatedHeader
        userEmail={user?.email || ""}
        context="admin"
        roleLabel="Admin"
        showLiveScan={true}
        showPromotions={true}
        leftSlot={(
          <div className="flex items-center gap-3">
            <LogoShield className="h-7 w-7" />
            <div className="flex flex-col leading-tight">
              <span className="text-sm font-mono text-muted-foreground">ShadowScan Portal</span>
              <span className="text-xl font-heading font-bold tracking-tight">Admin Console</span>
            </div>
          </div>
        )}
        centerSlot={(
          <Button variant="ghost" size="sm" onClick={() => navigate("/portal/admin")}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Admin console home
          </Button>
        )}
      />
      <main className="relative z-10 container mx-auto px-4 py-8 max-w-7xl">
        <AutoScanApp />
      </main>
      <CurrencyDock />
    </div>
  );
}
